import { Mail } from "lucide-react";

// Presentation only: reserved intake addresses are not connected company mailboxes.
export default function IntakeMailboxPanel() {
 return <section className="dad-panel dad-mailbox" data-testid="intake-email-card" aria-labelledby="mailbox-title">
  <span className="dad-eyebrow"><Mail size={16}/> Casella aziendale</span>
  <h2 id="mailbox-title">Nessuna casella aziendale collegata</h2>
  <p>Il collegamento alle email aziendali esistenti non è disponibile in questa versione. Nessuna ricezione, bozza o invio è attivo da questa schermata.</p>
  <dl className="dad-mailbox-fields">
   <div><dt>Indirizzo</dt><dd>Non configurato</dd></div><div><dt>Provider</dt><dd>Non configurato</dd></div>
   <div><dt>Ricezione</dt><dd>Non collegata</dd></div><div><dt>Bozze consentite</dt><dd>Non abilitate</dd></div>
   <div><dt>Invio</dt><dd>Non autorizzato</dd></div><div><dt>Ultima sincronizzazione</dt><dd>Non disponibile</dd></div>
   <div><dt>Stato</dt><dd>Collegamento non disponibile</dd></div>
  </dl>
  <button type="button" className="btn-ghost" disabled aria-describedby="mailbox-unavailable">Collega una casella</button>
  <p id="mailbox-unavailable" className="dad-caption">Disponibile in una fase successiva. Continua ad acquisire documenti con Scansiona.</p>
  <details className="dad-mailbox-permissions"><summary>Livelli di autorizzazione futuri</summary>
   <ol><li>Lettura</li><li>Bozze</li><li>Invio con autorizzazione</li><li>Automazioni autorizzate</li></ol>
   <p>Impostazione futura prevista: invio con autorizzazione. Nessun permesso è attivo o modificabile qui.</p>
  </details>
 </section>;
}
